import React from "react";
import { Input } from "@progress/kendo-react-inputs";
import { provideLocalizationService } from "@progress/kendo-react-intl";

const LogReportDetail = log => {
    var localizationService = provideLocalizationService(this);
    return (
        <div id="LogReportDetail">
            <form className="k-form">
                <fieldset>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="k-form-field">
                                <span>{localizationService.toLanguageString("", "Id")}</span>
                                <Input value={log.id} disabled />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="k-form-field">
                                <span>{localizationService.toLanguageString("", "Level")}</span>
                                <Input value={log.level} disabled />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="k-form-field">
                                <span>{localizationService.toLanguageString("", "Date")}</span>
                                <Input value={log.date.toLocaleString()} format="{0:dd. MM. yyyy - H:mm:ss}" disabled />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="k-form-field">
                                <span>{localizationService.toLanguageString("", "Thread")}</span>
                                <Input value={log.thread} disabled />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="k-form-field">
                                <span>{localizationService.toLanguageString("", "Meno")}</span>
                                <Input value={log.meno} disabled />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="k-form-field">
                                <span>{localizationService.toLanguageString("", "Celé meno")}</span>
                                <Input value={log.celeMeno} disabled />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="k-form-field">
                                <span>{localizationService.toLanguageString("", "Skratka skladu")}</span>
                                <Input value={log.skratka} disabled />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="k-form-field">
                                <span>{localizationService.toLanguageString("", "Názov skladu")}</span>
                                <Input value={log.nazov} disabled />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="k-form-field">
                                <span>{localizationService.toLanguageString("", "Logger")}</span>
                                <Input value={log.logger} disabled />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="k-form-field">
                                <span>{localizationService.toLanguageString("", "Message")}</span>
                                <textarea id="LogMessageTextArea" value={log.message} className="k-textarea" readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="k-form-field">
                                <span>{localizationService.toLanguageString("", "Exception")}</span>
                                <textarea id="LogExceptionTextArea" value={log.exception} className="k-textarea" readOnly />
                            </div>
                        </div>
                    </div>
                </fieldset>
            </form>
        </div>
    );
};

export default LogReportDetail;



// WEBPACK FOOTER //
// ./src/components/views/LogReport/LogReportDetail.js